<div
  [class]="isDisabled ? 'dashed-layout-disabled' : 'dashed-layout'"
  [style.height]="height"
>
  <img [src]="image" alt="image-content" />
  <div class="title">{{ title }}</div>
  <div class="text">{{ text }}</div>
</div>
